import { useMutation } from 'react-query';
import { useAPI } from '@axo/shared/data-access/provider';
import { sms_api } from '@axo/shared/data-access/api';

export function usePatchSMS() {
  const api = useAPI();

  return useMutation(sms_api.patchSMS(api));
  // invalidateQueries is not called in onSuccess callback.
  // invalidateQueries is handled with websocket messages
}
